(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_withApollo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9035);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5641);
/* harmony import */ var components_ApplyLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6193);
/* harmony import */ var _apply_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8105);
/* harmony import */ var _apply_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_apply_module_css__WEBPACK_IMPORTED_MODULE_5__);






//TODO: Setup proptypes
function Apply(param) {
    var image = param.image, uiColour = param.uiColour, desktopTitle = param.desktopTitle, desktopContent = param.desktopContent, mobileTitle = param.mobileTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ApplyLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        uiColour: uiColour,
        headerFloat: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().mainContent),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().imageWrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: image.sourceUrl,
                                alt: "",
                                className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().image)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().imageContent),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().title),
                                        children: mobileTitle
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        type: "Apply",
                                        href: "start",
                                        className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().button),
                                        children: [
                                            "Apply",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "12.759",
                                                height: "8.094",
                                                viewBox: "0.62 -0.327 12.759 8.094",
                                                className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().buttonIcon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    fill: "none",
                                                    stroke: "#ffffff",
                                                    d: "M1 0l5.965 7L13 0"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().desktopContent),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().title),
                            children: desktopTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().desktopText),
                            dangerouslySetInnerHTML: {
                                __html: desktopContent
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            type: "Apply",
                            href: "start",
                            className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().button),
                            children: [
                                "Apply now",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "12.759",
                                    height: "8.094",
                                    viewBox: "0.62 -0.327 12.759 8.094",
                                    className: (_apply_module_css__WEBPACK_IMPORTED_MODULE_5___default().buttonIcon),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "none",
                                        stroke: "#000",
                                        d: "M1 0l5.965 7L13 0"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Apply);


/***/ }),

/***/ 8105:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"apply_spacing--xxxs__cmRZA","spacing--xxs":"apply_spacing--xxs__JX9Rp","spacing--xs":"apply_spacing--xs__3kNjx","spacing--sm":"apply_spacing--sm__HqSPo","spacing--md":"apply_spacing--md__LkGmz","spacing--lg":"apply_spacing--lg__2HbXF","spacing--xl":"apply_spacing--xl__aMfbX","spacing--xxl":"apply_spacing--xxl__183HX","spacing--xxxl":"apply_spacing--xxxl__Pu5FE","container":"apply_container___qMU9","mainContent":"apply_mainContent___k7R2","imageWrapper":"apply_imageWrapper__H7PDi","image":"apply_image__q0Nco","imageContent":"apply_imageContent__TAZX4","button":"apply_button__GbLxX","title":"apply_title__GGwXe","buttonIcon":"apply_buttonIcon__4xXE5","countdownButton":"apply_countdownButton__Ppo79","desktopContent":"apply_desktopContent__JgUQE","desktopText":"apply_desktopText__MZaIW","fadeInItems":"apply_fadeInItems__4mHG6"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [891,984,193,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);